import { api } from 'app/config/apiConfig';
import { VerificationDocument } from '../model/types';

export const deleteVerificationPhotoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteVerificationPhoto: builder.mutation<VerificationDocument, string>({
      query: (verificationPhotoId: string) => ({
        url: `/verification-photos/${verificationPhotoId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VerificationDocuments', 'Users'],
    }),
  }),
});

export const { useDeleteVerificationPhotoMutation } = deleteVerificationPhotoApi;
